import type { DashboardArea, SiteRole } from '~/types/practice'
import { defaultStaffPermissions, resolveStaffPermissions, type StaffPermissions } from '~/utils/practice/permissions'

export function allowsArea(role: SiteRole, area: DashboardArea): boolean {
  if (role === 'owner') return true
  if (role === 'secretary') return area === 'bookingDesk' || area === 'reception'
  return area === 'bookingDesk' || area === 'visit' || area === 'health'
}

export function staffPermissionsFor(role: SiteRole, raw?: unknown): StaffPermissions | null {
  if (role === 'owner') return null
  return resolveStaffPermissions(role, raw)
}

export function isDashboardPathAllowed(role: SiteRole, path: string, rawPermissions?: unknown): boolean {
  if (role === 'owner') return true
  const permissions = staffPermissionsFor(role, rawPermissions ?? null) ?? defaultStaffPermissions(role)
  const normalized = path.replace(/\/$/, '') || '/dashboard'
  if (normalized === '/dashboard/settings' || normalized === '/dashboard/unavailable') return true
  if (normalized === '/dashboard/booking') return permissions['booking.view']
  if (normalized === '/dashboard/booking/cancellations') {
    return permissions['booking.view'] && permissions['booking.manage']
  }
  if (normalized === '/dashboard/booking/schedule' || normalized.startsWith('/dashboard/booking/schedule/')) {
    return permissions['booking.schedule']
  }
  if (normalized === '/dashboard/booking/virtual-visits' || normalized.startsWith('/dashboard/booking/virtual-visits/')) {
    return permissions['visit.view']
  }
  if (normalized === '/dashboard/reception' || normalized.startsWith('/dashboard/reception/')) {
    return permissions['reception.view']
  }
  if (normalized.startsWith('/dashboard/health/forms')) return permissions['health.config']
  if (normalized === '/dashboard/health' || normalized.startsWith('/dashboard/health/')) {
    return permissions['health.view']
  }
  return false
}

export function practiceHomePath(role: SiteRole, rawPermissions?: unknown): string {
  if (role === 'owner') return '/dashboard'
  const permissions = staffPermissionsFor(role, rawPermissions ?? null) ?? defaultStaffPermissions(role)
  if (permissions['booking.view']) return '/dashboard/booking'
  if (permissions['reception.view']) return '/dashboard/reception'
  if (permissions['visit.view']) return '/dashboard/booking/virtual-visits'
  if (permissions['health.view']) return '/dashboard/health'
  return '/dashboard/settings'
}
